<template>
    <section class="onboarding-wrapper onboarding-de onboarding-it">
        <progress-bar v-if="this.questionNumber != 4" :question-number="questionNumber" :number-of-tabs="numberOfTabs" @goBack="prevTab" :show-back-button="showBackButton"></progress-bar>

        <div class="container">    
            <onboarding-first-question v-if="this.questionNumber === 1" @clicked="setDataFromChild"></onboarding-first-question>
            <onboarding-second-question v-if="this.questionNumber === 2" :data="apiData" @clicked="setDataFromChild"></onboarding-second-question>
            <onboarding-third-question v-if="this.questionNumber === 3" :data="apiData" @clicked="setDataFromChild"></onboarding-third-question>
            <onboarding-fourth-question v-if="this.questionNumber === 4" :data="apiData" @clicked="setDataFromChild"></onboarding-fourth-question>
            <onboarding-modal></onboarding-modal>
        </div>
    </section>
</template>

<script>
import OnboardingFirstQuestion from './OnboardingFirstQuestion'
import OnboardingSecondQuestion from './OnboardingSecondQuestion'
import OnboardingThirdQuestion from './OnboardingThirdQuestion'
import OnboardingFourthQuestion from './OnboardingFourthQuestion'
import OnboardingModal from './OnboardingModal'

export default {
    components: { 
        OnboardingFirstQuestion,
        OnboardingSecondQuestion,
        OnboardingThirdQuestion,
        OnboardingFourthQuestion,
        OnboardingModal
    },
    data() {
        return {
            questionNumber: 1,
            numberOfTabs: 3,
            submit: false,
            utm: false,
            showBackButton: true,
            apiData: {
                phone: null,
                phone_country: null,
                meta: {},
                id: null,
                email: null,
                ga_client_id: null,
                gcl_id: null,
                from_rwe_web: false
            }
        }
    },

    watch: {
        questionNumber() {
            this.replaceUrl()
        }
    },

    mounted() {
        const uri = new URI(location.href)
        
        this.replaceUrl()

        if (uri.hasQuery('step')) {
            this.questionNumber = parseInt(uri.search(true).step)
        }
    },

    methods: {
        setDataFromChild(apiData) {     
            if (this.questionNumber === 2) {                        
                this.apiData.meta = [{'motivation_onboarding': apiData.motivation}]
            }

            $('html, body').animate({scrollTop: $("#page").offset().top}, 0)

            this.nextTab()
        },
        prevTab() {
            if (this.questionNumber === 1) {
                window.location.href = '/onboarding'
            } else {
                this.questionNumber = this.questionNumber - 1
            }
        },
        nextTab() {
            this.questionNumber = this.questionNumber + 1
        },
        replaceUrl() {            
            if (window.location.search && !window.location.href.includes('?step')) {
                var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search;
                var step = new URL(window.location.href).searchParams.get("step");
                if (step) {
                    refresh = refresh.slice(0, -7) + '&step='+this.questionNumber;
                } else {
                    refresh = refresh + '&step='+this.questionNumber;
                }
            } else {
                var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '?step='+this.questionNumber;
            }
            
            window.history.replaceState({ path: refresh }, '', refresh);
        }
    }
}
</script>